// Shared action types
export const SET_SELECTED_NAVIGATION_ID = 'SET_SELECTED_NAVIGATION_ID';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SET_SELECTED_ART_EVENT_ID = 'SET_SELECTED_ART_EVENT_ID';
export const SET_SELECTED_ART_EVENT_STATUS = 'SET_SELECTED_ART_EVENT_STATUS';

export interface SetSelectedArtEventStatus {
  type: typeof SET_SELECTED_ART_EVENT_STATUS;
  payload: string | null | undefined;
}

export interface SetSelectedNavigationIdAction {
  type: typeof SET_SELECTED_NAVIGATION_ID;
  payload: string;
}

export interface SetCurrentUserAction {
  type: typeof SET_CURRENT_USER;
  payload: {
    userId: string;
    role: string;
    firstName: string;
    lastName: string;
    email: string;
    privilegedMode: boolean;
  };
}

export interface SetUserPermissionsAction {
  type: typeof SET_USER_PERMISSIONS;
  payload: string[] | null;
}

export interface SetSelectedArtEventIdAction {
  type: typeof SET_SELECTED_ART_EVENT_ID;
  payload: string | undefined;
}

export type SharedActionTypes =
  | SetSelectedNavigationIdAction
  | SetCurrentUserAction
  | SetUserPermissionsAction
  | SetSelectedArtEventIdAction
  | SetSelectedArtEventStatus;
